/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleStop extends models.BillingRule {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleStop");
    }

    getFixupPrototypeFunction() { return BillingRuleStop.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleStop>): BillingRuleStop {
        let obj = Object.assign(new BillingRuleStop(), model);
        BillingRuleStop.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleStop>): BillingRuleStop {
        if (!model) return null;
        return BillingRuleStop.newInstance(<BillingRuleStop> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleStop) {
        if (!obj) return;

        models.BillingRuleStop.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleStop): boolean {
        if (models.BillingRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleStop.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
